<button *ngIf="lazy" class="tutorial" type="button" (click)="start()">
  <i class="question-mark"></i>
</button>
